import React, { useState, useEffect } from "react";
import Label from "components/Form/Label";
import TextInput from "components/Form/TextInput";
import ProgressBar from "../ProgressBar";
import PreviousButton from "../PreviousButton";
import NextButton from "../NextButton";

const Step = ({
  onChange,
  formData,
  nextStep,
  prevStep,
  onUserSignUpByStep,
  currentStep,
  totalSteps,
}) => {
  const [hasError, setHasError] = useState(false);
  const [invalidPasswords, setInvalidPasswords] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [editingPassword, setEditingPassword] = useState(true);

  const checkPassword = () => {
    // Check if password has at least 6 characters
    if (!formData.password) {
      setErrorMessage("Enter Password");
      setEditingPassword(true);
      return false;
    } else if (formData.password.length < 6) {
      setEditingPassword(true);
      setErrorMessage("Your password must be at least 6 characters in length");
      return false;
    } else {
      setHasError(false);
      return true;
    }
  };

  useEffect(() => {
    if (hasError) checkPassword();
  }, [hasError, formData]);

  return (
    <div className="mx-auto w-full lg:w-[480px]">
      <div>
        <h1 className="my-4 text-2xl md:text-3xl font-bold tracking-tight text-primary-700">
          Let's lock it down 🔓
        </h1>
        <p className="my-2 text-sm text-primary-700">
          Choose a secure password
        </p>
        <ul className="list-disc italic text-base pl-6">
          <li className="text-sm">6 characters minimum</li>
          <li className="text-sm">Avoid using 'password' or your user name</li>
        </ul>
      </div>
      <div className="mt-8">
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
        <form action="#" method="POST" className="space-y-6">
          <div>
            <Label>Password</Label>
            <TextInput
              id="password"
              name="password"
              type="password"
              value={formData.password}
              onChange={(value) => {
                onChange({
                  ...formData,
                  password: value,
                });
                // reset confirm password field validation
                if (invalidPasswords) setInvalidPasswords(false);
              }}
              hasError={
                hasError && !errorMessage.includes("match")
                  ? errorMessage
                  : null
              }
              onBlur={checkPassword}
              required
            />
          </div>
          <div>
            <Label>Confirm Password</Label>
            <TextInput
              id="confirm_password"
              name="confirm_password"
              type="password"
              value={formData.password_confirmation}
              onChange={(value) => {
                onChange({
                  ...formData,
                  password_confirmation: value,
                });

                if (invalidPasswords && formData.password === value) {
                  setInvalidPasswords(false);
                }
              }}
              hasError={
                invalidPasswords &&
                !editingPassword &&
                formData.password.length >= 6 &&
                (!formData.password_confirmation ||
                  formData.password !== formData.password_confirmation)
                  ? "Passwords do not match"
                  : null
              }
              required
            />
          </div>
          <div className="w-full flex justify-between">
            <PreviousButton onClick={prevStep} />
            <NextButton
              onClick={() => {
                if (checkPassword()) {
                  setEditingPassword(false);
                  if (formData.password === formData.password_confirmation) {
                    onUserSignUpByStep(() => nextStep());
                  } else {
                    setInvalidPasswords(true);
                  }
                } else {
                  setHasError(true);
                }
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Step;
